import React from 'react'
import { OperationMode } from '../../../../domain/operationMode'
import { OPERATION_MODE_CODES } from '../../../../domain/operationModeConstants'

interface Props {
    operationMode: OperationMode
}

function RobotIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
            <path d="M6.66666 10.6667H9.33332M5.99999 4.66667L5.33332 2M9.99999 4.66667L10.6667 2M4.66666 4.66667H11.3333C11.6869 4.66667 12.0261 4.80714 12.2761 5.05719C12.5262 5.30724 12.6667 5.64638 12.6667 6V6.66667L13.3333 7.33333V9.33333L12.6667 10V12C12.6667 12.3536 12.5262 12.6928 12.2761 12.9428C12.0261 13.1929 11.6869 13.3333 11.3333 13.3333H4.66666C4.31303 13.3333 3.9739 13.1929 3.72385 12.9428C3.4738 12.6928 3.33332 12.3536 3.33332 12V10L2.66666 9.33333V7.33333L3.33332 6.66667V6C3.33332 5.64638 3.4738 5.30724 3.72385 5.05719C3.9739 4.80714 4.31303 4.66667 4.66666 4.66667ZM5.99999 7.66667C5.99999 7.85076 5.85075 8 5.66666 8C5.48256 8 5.33332 7.85076 5.33332 7.66667C5.33332 7.48257 5.48256 7.33333 5.66666 7.33333C5.85075 7.33333 5.99999 7.48257 5.99999 7.66667ZM10.6667 7.66667C10.6667 7.85076 10.5174 8 10.3333 8C10.1492 8 9.99999 7.85076 9.99999 7.66667C9.99999 7.48257 10.1492 7.33333 10.3333 7.33333C10.5174 7.33333 10.6667 7.48257 10.6667 7.66667Z" stroke="#0084FF" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

function ScannerIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
            <g clipPath="url(#clip0_5171_3934)">
                <path d="M1.33334 3.83325V2.99992C1.33334 2.55789 1.50894 2.13397 1.8215 1.82141C2.13406 1.50885 2.55798 1.33325 3.00001 1.33325H4.66668M1.33334 12.1666V12.9999C1.33334 13.4419 1.50894 13.8659 1.8215 14.1784C2.13406 14.491 2.55798 14.6666 3.00001 14.6666H4.66668M11.3333 1.33325H13C13.442 1.33325 13.866 1.50885 14.1785 1.82141C14.4911 2.13397 14.6667 2.55789 14.6667 2.99992V3.83325M11.3333 14.6666H13C13.442 14.6666 13.866 14.491 14.1785 14.1784C14.4911 13.8659 14.6667 13.4419 14.6667 12.9999V12.1666M2.16668 7.99992H13.8333" stroke="#FF8802" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_5171_3934">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}

interface Variant {
    bg: string
    text: string
    Icon: () => React.ReactElement
}

const variants: Record<string, Variant> = {
    [OPERATION_MODE_CODES.SORTER]: {
        bg: 'bg-[#E6F3FF]',
        text: 'text-[#0084FF]',
        Icon: RobotIcon,
    },
    [OPERATION_MODE_CODES.CLASSIFICATION]: {
        bg: 'bg-[#FFF3E6]',
        text: 'text-[#FF8802]',
        Icon: ScannerIcon,
    },
}

const defaultVariant: Variant = {
    bg: 'bg-[#F1F5F9]',
    text: 'text-[#475569]',
    Icon: ScannerIcon,
}

export function OperationModeBadge({ operationMode }: Props) {
    const { bg, text, Icon } = variants[operationMode.code] ?? defaultVariant

    return (
        <span className={`inline-flex items-center gap-1 px-[8px] py-[6px] h-[28px] rounded-full text-sm font-normal leading-[18px] capitalize ${bg} ${text}`}>
            <Icon />
            {operationMode.name}
        </span>
    )
}
